export default {
  props: {
    field: String,
    type: String,
    label: [Boolean, String],
    hint: String,
    placeholder: String,
    cssClass: String,
  },
  computed: {
    model () {
      return this.$parent.model
    },
    inputLabel () {
      if (this.label === false) {
        return ''
      } else {
        return this.model.fieldLabel(this.field)
      }
    },
    inputHint () {
      return this.hint || this.model.fieldHint(this.field)
    },
    inputOptions () {
      return this.options || this.model.fieldOptions(this.field)
    },
    inputPlaceholder () {
      return this.placeholder || this.model.fieldPlaceholder(this.field)
    },
    isInvalid () {
      return this.model.fieldInvalid(this.field)
    },
    validationErrors () {
      return this.model.fieldErrors(this.field)
    }
  }
}



// WEBPACK FOOTER //
// ./src/fractel/components/vue-mc/form/input-helpers.js